import { css } from "@compiled/react";

import { Picture } from "../../../../components/wpl/image/src/image";
import { PictureImageProps } from "../../../../components/wpl/image/src/image";

const customerSectionStyles = css({
    "justifyContent": "center",
    "alignItems": "center",
    "textAlign": "center",
    "padding": "1rem 0 2rem",

    "@media only screen and (min-width: 768px)": {
        paddingBlockStart: "4rem",
        paddingBlockEnd: "4rem"
    }
});

const h3Styles = css({
    fontSize: "24px",
    lineHeight: "1.33333333",
    fontWeight: "500",
    color: "#253858",
    padding: "1rem 1rem 2rem",
    marginBlock: "unset",
    textWrap: "balance"
});

const containerStyles = css({
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "gap": "32px 40px",
    "alignItems": "center",
    "textAlign": "center",
    "flexWrap": "wrap",
    "marginInline": "auto",
    "maxWidth": "1200px",
    "padding": "0",

    "@media only screen and (min-width: 768px)": {
        flexDirection: "row",
        alignItems: "stretch",
        padding: "1rem"
    }
});

const imageStyles = css({
    height: "45px",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        height: "100%",
        width: "auto"
    }
});

const largeLogoStyles = css({
    "@media only screen and (min-width: 768px)": {
        width: "150px",
        height: "96px"
    }
});

const smallLogoStyle = css({
    "@media only screen and (min-width: 768px)": {
        height: "35px"
    }
});

export interface PaidSocialProofProps {
    headerText?: string | null;
    logos?: PictureImageProps[] | null;
    altDarkLogo?: PictureImageProps[] | null;
    logoSize?: "small" | "large";
}

export const PaidSocialProof = ({
    headerText,
    logos,
    logoSize = "small"
}: PaidSocialProofProps) => {
    return (
        <section css={customerSectionStyles}>
            <h3 css={h3Styles}>{headerText}</h3>
            <div css={containerStyles}>
                {logos?.map((inlineLogo, index) => (
                    <div
                        key={index}
                        css={[
                            imageStyles,
                            logoSize === "small"
                                ? smallLogoStyle
                                : largeLogoStyles
                        ]}
                    >
                        <Picture image={{ ...inlineLogo }} />
                    </div>
                ))}
            </div>
        </section>
    );
};

PaidSocialProof.displayName = "PaidSocialProof";
